import type { ActivityModule } from '../../core/activity';
import { mountGuesscount } from './ui';
import levelsData from './levels.json';
import './style.css';

export const guesscount: ActivityModule = {
  id: 'guesscount',
  title: 'Adivinhe a conta',
  description: 'Combine números e operadores pra chegar no resultado pedido. Treino de cálculo decomposto.',
  ageMin: 7,
  ageMax: 11,
  difficulty: 3,
  iconPath: 'assets/gcompris-AGPL/guesscount/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountGuesscount,
};
